export default __webpack_public_path__ + "static/media/cross.0459a873.svg";